import React, { Component } from 'react'
import PaginationControls from './PaginationControls'
import KeywordTable from './KeywordTable'

const RANK_DEPENDENT_FIELDS = ['rank_delta', 'ranking_url']

class KeywordsDisplay extends Component {

  state = {
    keywords: [], // Pre filtered results,
    sortedResults: [], // All rows, sorted
    currentResults: [], // The sorted rows for the current page
    currentPage: null,
    sortField: this.props.sortField || "volume",
    sortDescending: this.props.sortDescending ?? true,
    perPage: parseInt(this.props.perPage) > 0 ? parseInt(this.props.perPage) : 100,
    selectedItems: [],
    lastSelectedItem: null,
    isSelectAll: false
  }

  constructor(props) {
    super(props)
    this.handleSetSorting = this.handleSetSorting.bind(this)
    this.handleSelectItem = this.handleSelectItem.bind(this)
    this.handleToggleSelectAll = this.handleToggleSelectAll.bind(this)
  }


  componentDidUpdate() {
    if (this.props.keywords && JSON.stringify(this.props.keywords) != JSON.stringify(this.state.keywords)) {
      this.updateSourceKeywords();
    }
  }

  handleSetSorting({sortDescending, sortField}) {
    if (sortField != this.state.sortField) sortDescending = true; // If changing to a new column, start with sortDescending.
    this.setState({sortField, sortDescending }, () => {
      this.updateSorting();
    });
  };

  updateSorting() {
    const { sortField, sortDescending, currentPage, perPage } = this.state;

    const { keywords } = this.state;

    // if (keywords.length < 1) return;

    const sortedResults = keywords.sort((a, b) => {

      const aValue = a[sortField]
      const bValue = b[sortField]
      const aNull = aValue == null
      const bNull = bValue == null

      if (aNull && bNull) {
        if (a.stale && !b.stale) return 1
        if (!a.stale && b.stale) return -1
        if (RANK_DEPENDENT_FIELDS.includes(sortField)) {
          const aRank = a.rank
          const bRank = b.rank
          const aRankNull = aRank == null
          const bRankNull = bRank == null
          if (aRankNull && bRankNull) return 0
          if (aRankNull) return 1
          if (bRankNull) return -1
          if (aRank === -1 && bRank === -1) return 0
          if (aRank === -1) return 1
          if (bRank === -1) return -1
          return sortDescending ? bRank - aRank : aRank - bRank
        }
        return 0
      }
      if (aNull) return 1
      if (bNull) return -1

      if (aValue === -1 && bValue === -1) {
        if (a.stale && !b.stale) return 1
        if (!a.stale && b.stale) return -1
        return 0
      }
      if (aValue === -1) return 1
      if (bValue === -1) return -1

      if (typeof aValue === 'string') {
        return sortDescending ? bValue.localeCompare(aValue) : aValue.localeCompare(bValue)
      }

      return sortDescending ? bValue - aValue : aValue - bValue;

      // // Sorting for change metrics
      // if (CHANGE_METRICS.includes(sortField)) {
      //   if (!a[sortField]) return 1; // Any results with no data should be last no matter whether ascending or descending
      //   return (a[sortField] > (b[sortField]))
      //     ? (!sortDescending ? 1 : -1)
      //     : (sortDescending ? 1 : -1)
      // }

      // // Sorting for all other metrics
      // const aValue = a[sortField] ?? -1
      // const bValue = b[sortField] ?? -1
    
      // if (aValue === -1 && bValue === -1) return 0
      // if (aValue === -1) return 1
      // if (bValue === -1) return -1
    
      // return sortDescending ? bValue - aValue : aValue - bValue

      if (!a[sortField] || a[sortField] < 0) {
        return 1; // Any results with no data should be last no matter whether ascending or descending
      }
      return (a[sortField] > (b[sortField] || -1))// || a.pending)
        ? (!sortDescending ? 1 : -1)
        : (sortDescending ? 1 : -1)

    });
    this.setState({ sortedResults }, () => {
      this.setPage({currentPage, perPage});
    });
    this.props.onUpdateSorting(sortField, sortDescending);
  }

  updateSourceKeywords() {
    const { keywords } = this.props;
    // const { sortDescending, sortField } = this.state;
    this.setState({ keywords }, () => {
      // this.handleSetSorting({sortDescending, sortField});
      this.updateSorting();
    });
  }

  setPage = data => {
    const { currentPage, perPage } = data;
    const offset = (currentPage - 1) * perPage;
    const currentResults = this.state.sortedResults.slice(offset, offset + perPage);
    this.setState({ currentResults, currentPage, lastSelectedItem: null });
  }

  handleSelectItem(e, isShiftDown) {
    const { value } = e.target;
    const nextValue = this.getNextValue(value, isShiftDown);
    this.setState({ selectedItems: nextValue, lastSelectedItem: value });
    this.props.onChangeSelected(nextValue);
  }
  
  getNextValue(value, isShiftDown) {
    const { selectedItems } = this.state;
    const hasBeenSelected = !selectedItems.includes(value);
    
    if (isShiftDown) {
      const newSelectedItems = this.getNewSelectedItems(value);
      // de-dupe the array using a Set
      const selections = [...new Set([...selectedItems, ...newSelectedItems])];
      
      if (!hasBeenSelected) {
        return selections.filter(item => !newSelectedItems.includes(item));
      }
      
      return selections;
    }
    
    // if it's already in there, remove it, otherwise append it
    return selectedItems.includes(value)
    ? selectedItems.filter(item => item !== value)
    : [...selectedItems, value];
  }
  
  getNewSelectedItems(value) {
    const { lastSelectedItem, currentResults } = this.state;
    const currentSelectedIndex = currentResults.findIndex(item => item.keyword === value);
    const lastSelectedIndex = currentResults.findIndex(
      item => item.keyword === lastSelectedItem
    );
      
    return currentResults.slice(
      Math.min(lastSelectedIndex, currentSelectedIndex),
      Math.max(lastSelectedIndex, currentSelectedIndex) + 1
    ).map(item => item.keyword);
  }

  selectAllCurrent() {
    const { selectedItems } = this.state;
    const newSelectedItems = this.props.keywords.map(keyword => keyword.keyword);
    const selections = [...new Set([...selectedItems, ...newSelectedItems])];
    this.setState({selectedItems: selections});
    this.props.onChangeSelected(selections);
  }
  
  deselectAllCurrent() {
    const { selectedItems } = this.state;
    const newDeselectedItems = this.props.keywords.map(keyword => keyword.keyword);
    const selections = selectedItems.filter(item => !newDeselectedItems.includes(item));
    this.setState({selectedItems: selections});
    this.props.onChangeSelected(selections);
  }
  
  handleToggleSelectAll() {
    const isSelectAll = !this.state.isSelectAll;
    if (isSelectAll) {
      this.selectAllCurrent();
    } else {
      this.deselectAllCurrent();
    }
    this.setState({isSelectAll, lastSelectedItem: null})
  }
  
  render() {
    
    const { currentResults, perPage, sortField, sortDescending, selectedItems, sortedResults, isSelectAll } = this.state;
    const { fields, hasFilters, loading, failed, source, onClickResult, onClickSparkline, onClickStale, isFreeUser, onClickUnlock, serpsResults, possible } = this.props;
    
    const keywordsTableProps = {
      results: currentResults,
      onSetSorting: this.handleSetSorting,
      handleSelectItem: this.handleSelectItem,
      onToggleSelectAll: this.handleToggleSelectAll,
      totalResults,
      fields,
      hasFilters,
      loading,
      failed,
      source,
      sortField,
      sortDescending,
      onClickResult,
      onClickUnlock,
      isFreeUser,
      onClickSparkline,
      onClickStale,
      selectedItems,
      serpsResults,
      isSelectAll,
      possible
    }

    const totalResults = sortedResults ? sortedResults.length : 0;

    return (
      <>
        <KeywordTable {...keywordsTableProps} totalResults={totalResults}></KeywordTable>
        <PaginationControls
          totalRecords={totalResults}
          perPage={perPage}
          onPageChanged={this.setPage} />
      </>
    )
  }
}

export default KeywordsDisplay;
